import { render, staticRenderFns } from "./Vueltos.vue?vue&type=template&id=65d0c774"
import script from "./Vueltos.vue?vue&type=script&lang=js"
export * from "./Vueltos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports